/**
 * useTeamPhotos — hook per recuperare lista pubblica dipendenti + foto.
 * Cache localStorage 1h.
 */
import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CACHE_KEY = "team_photos_v1";
const TTL_MS = 60 * 60 * 1000;

export default function useTeamPhotos() {
  const [team, setTeam] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (raw) {
        const cached = JSON.parse(raw);
        if (cached.ts && Date.now() - cached.ts < TTL_MS && Array.isArray(cached.items)) {
          setTeam(cached.items);
          return;
        }
      }
    } catch (_e) { /* ignore */ }
    axios.get(`${API}/public/team/list`)
      .then((r) => {
        const items = r.data?.items || [];
        setTeam(items);
        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), items }));
        } catch (_e) { /* quota */ }
      })
      .catch(() => setTeam([]));
  }, []);

  /** Trova foto per slug/nome. Cerca match esatto su slug oppure su nome cognome. */
  const findPhoto = (nameOrSlug) => {
    if (!nameOrSlug) return null;
    const slug = nameOrSlug.toLowerCase().replace(/\s+/g, "-");
    const byName = team.find((m) => `${m.nome} ${m.cognome}`.toLowerCase() === nameOrSlug.toLowerCase());
    const bySlug = team.find((m) => m.slug === slug);
    return (byName || bySlug)?.photo_url || null;
  };

  return { team, findPhoto };
}
